
import React from 'react';

const DataSecurity = () => {
  return (
    <div>
      <h3 className="text-xl font-semibold mb-3">VII. Data security (cf. Art. 32 EU- GDPR)</h3>
      <p className="text-gray-600">
        We use appropriate technical and organizational security measures to protect your data against accidental or intentional manipulation, partial or total loss, destruction, or unauthorized access by third parties (e.g. SSL/TSL encryption for our Website), taking into account the state of the art, the implementation costs, and the nature, scope, context, and purposes of processing as well as the risks of a data breach (including its likelihood and severity) for the data subject. Our security measures are continuously improved in line with technological developments.
      </p>
      <p className="text-gray-600">
        We are happy to provide you with more detailed information upon request. Please contact our data protection officer (see Part A. Section IV.).
      </p>
    </div>
  );
};

export default DataSecurity;
